import { CardActionArea as MuiCardActionArea, CardMedia as MuiCardMedia, Grid } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useIntl } from "react-intl";
import { format } from "date-fns";

import type { IContract } from "@framework/types";
import { Card, Typography } from "@dzambalaorg/ui-kit";

interface IContractListItemProps {
  contract: IContract;
  path: string;
}

export const ContractListItem = (props: IContractListItemProps) => {
  const { contract, path } = props;
  const { formatMessage } = useIntl();

  return (
    <MuiCardActionArea component={RouterLink} to={`${path}/${contract.id}`}>
      <Card
        variant="outlined"
        header={
          <Card.Header
            title={<MuiCardMedia image={contract.imageUrl} title={`${contract.title}`} />}
            subheader={
              <Typography variant="h5" color="textPrimary">
                {contract.title}
              </Typography>
            }
          />
        }
      >
        <Card.Content>
          <Grid container size={12} mb={1}>
            <Grid size={6}>
              <Typography
                variant="body1"
                fontWeight={700}
              >{`${formatMessage({ id: "pages.marketplace.contracts.contractType" })}:`}</Typography>
            </Grid>
            <Grid size={6}>
              <Typography variant="body1" color="textSecondary">
                {contract.contractType}
              </Typography>
            </Grid>
          </Grid>

          {contract.symbol && (
            <Grid container size={12} mb={1}>
              <Grid size={6}>
                <Typography
                  variant="body1"
                  fontWeight={700}
                >{`${formatMessage({ id: "pages.marketplace.contracts.contractSymbol" })}:`}</Typography>
              </Grid>
              <Grid size={6}>
                <Typography variant="body1" color="textSecondary">
                  {contract.symbol}
                </Typography>
              </Grid>
            </Grid>
          )}
          <Grid container size={12}>
            <Grid size={6}>
              <Typography
                variant="body1"
                fontWeight={700}
              >{`${formatMessage({ id: "pages.marketplace.contracts.createdAt" })}:`}</Typography>
            </Grid>
            <Grid size={6}>
              <Typography variant="body1" color="textSecondary">
                {format(contract.createdAt, "yyyy-MM-dd")}
              </Typography>
            </Grid>
          </Grid>
        </Card.Content>
      </Card>
    </MuiCardActionArea>
  );
};
